module.exports = "/_next/static/images/pricing-plans-consulting-service-2-b08ad7312d01dba98b431a4053a32646.webp";